import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const Product3D: React.FunctionComponent<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 64 64" {...props}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <rect fillRule="nonzero" x="0" y="0" width="64" height="64"></rect>
                    <path
                        d="M41,13 C39.2222222,9.44444444 36.5555556,7.66666667 33,7.66666667 C29.4444444,7.66666667 26.3333333,10.3333333 23.6666667,15.6666667 C17.4444444,30.7777778 17.4444444,43.6666667 23.6666667,54.3333333 C29.8888889,65 36.1111111,65 42.3333333,54.3333333 C45,49.8888889 46.3333333,43.2222222 46.3333333,34.3333333"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform="translate(32.666667, 35.000000) rotate(-90.000000) translate(-32.666667, -35.000000) "
                    ></path>
                    <polyline
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform="translate(33.333333, 21.333333) rotate(-90.000000) translate(-33.333333, -21.333333) "
                        points="38.6666667 24 33.3333333 18.6666667 28 24"
                    ></polyline>
                    <path
                        d="M38.8843537,10.3333333 C37.1428571,6.77777778 34.5306122,5 31.047619,5 C27.5646259,5 24.5170068,7.66666667 21.9047619,13 C15.8095238,28.1111111 15.8095238,41 21.9047619,51.6666667 C28,62.3333333 34.0952381,62.3333333 40.1904762,51.6666667 C42.8027211,47.2222222 44.1088435,40.5555556 44.1088435,31.6666667"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <polyline
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        points="49.3333333 35.6666667 44.1088435 30.3333333 38.8843537 35.6666667"
                    ></polyline>
                </g>
            </g>
        </SvgIcon>
    );
};

export { Product3D };
